export const RoleInfo = {
  TANK: { koname: "돌격", enname: "tank", row: 4 },
  DPS: { koname: "공격", enname: "dps", row: 6 },
  SUP: { koname: "지원", enname: "support", row: 4 },
};
